import { createI18n } from "vue-i18n";
import es_views from "./locals/es/views.json";
import es_components from "./locals/es/components.json";
import es_globals from "./locals/es/globals.json";
import en_views from "./locals/en/views.json";
import en_components from "./locals/en/components.json";
import en_globals from "./locals/en/globals.json";

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : navigator.language.split("-")[0],
  fallbackLocale: "es", // set fallback locale
  silentFallbackWarn: true,
  globalInjection: true,
  messages: {
    es: {
      views: es_views,
      components: es_components,
      globals: es_globals,
    },
    en: {
      views: en_views,
      components: en_components,
      globals: en_globals,
    },
  },
});

export default i18n;
